let customHeaders: Record<string, string> = {};
let selectedAccountId: string | null = null;

/**
 * Set custom headers to include on every apiFetch request.
 * Used to inject Gorgias product tokens.
 */
export function setCustomHeaders(headers: Record<string, string>) {
  customHeaders = headers;
}

/**
 * Set the active account ID. When set, every apiFetch request
 * includes an X-Account-Id header so the server selects the right account.
 */
export function setSelectedAccountId(id: string | null) {
  selectedAccountId = id;
}

/** Read the current selected account ID (used by the LangGraph client). */
export function getSelectedAccountId(): string | null {
  return selectedAccountId;
}

/** Read the current custom headers (used for raw fetch calls that bypass apiFetch). */
export function getCustomHeaders(): Record<string, string> {
  return { ...customHeaders };
}

/**
 * Authenticated fetch wrapper. Cookies are sent automatically
 * for same-origin requests.
 */
export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(selectedAccountId ? { 'X-Account-Id': selectedAccountId } : {}),
      ...customHeaders,
      ...options?.headers,
    },
  });

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`API ${res.status}: ${body}`);
  }

  return res.json() as Promise<T>;
}
